export const setLayout = (payload) => ({
  type: 'setLayout',
  payload,
});

export const toggleAside = (payload) => ({
  type: 'toggleAside',
  payload,
});
